/**
 * Whether the logged-in student is a mobile-app user (is_allow_mobile).
 * Wizard sidebar + routes are limited to these accounts.
 */
export function readStudentUserData() {
  try {
    const raw = localStorage.getItem("userData");
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function studentIsAllowMobile(userData = readStudentUserData()) {
  if (!userData || typeof userData !== "object") return false;
  return Boolean(userData.is_allow_mobile);
}

/** Merge profile/login flags into localStorage userData. */
export function patchStudentUserData(partial) {
  const current = readStudentUserData() || {};
  const next = { ...current, ...partial };
  try {
    localStorage.setItem("userData", JSON.stringify(next));
  } catch {
    /* ignore quota */
  }
  return next;
}
